import classNames from "classnames";
import React, { ButtonHTMLAttributes, useEffect, useState } from "react";
import { PhosphorFunnel, PhosphorList } from "./PhosphorIcon";

export interface PhosphorIconButtonWithLabelProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  selected?: boolean
  iconSize?: "regular" | "large"
  label: string
  dot?: boolean
}

export const PhosphorIconButtonWithLabel = (props: React.PropsWithChildren<PhosphorIconButtonWithLabelProps>) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isCollapsing, setIsCollapsing] = useState(false);
  const [isSelected, setIsSelected] = useState(props.selected);

  const className = classNames("phosphor-icon-button-with-label", {
    "phosphor-icon-button-with-label--selected": props.selected,
    "phosphor-icon-button-with-label--collapsing": isCollapsing,
    "phosphor-icon-button-with-label--hover": isHovered && !isSelected,
    "phosphor-icon-button-with-label--default": !isCollapsing && !isHovered && !isSelected
  });

  useEffect(() => {
    if (props.selected && props.selected !== isSelected) {
      setIsHovered(false);
      setIsSelected(true);
    } else if (!props.selected && props.selected !== isSelected) {
      setIsSelected(false);
      setIsCollapsing(true);
      setTimeout(() => setIsCollapsing(false), 300);
    }
  }, [props.selected]);

  const onMouseOver = () => {
    if (isSelected || isCollapsing) {
      return;
    }

    setIsHovered(true);
  }

  const onMouseLeave = () => {
    if (isSelected) {
      return;
    }

    setIsHovered(false);
    setIsCollapsing(true);
    setTimeout(() => setIsCollapsing(false), 300);
  }

  return <button
    className={className}
    onClick={props.onClick}
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
  >
    <span className="phosphor-icon-button-with-label-content">
      {props.children}
      {props.dot && <span className="phosphor-icon-button-with-label-dot" />}
    </span>
    <span style={{ marginTop: 1 }} className="phosphor-icon-button-with-label-label label-text-medium">{props.label}</span>
  </button>
};

export const PhosphorListButtonWithLabel = (props: Omit<PhosphorIconButtonWithLabelProps, "label">) =>
  <PhosphorIconButtonWithLabel label={RESX.GeneralLabels.List} {...props}>
    <PhosphorList {...props} />
  </PhosphorIconButtonWithLabel>;

export const PhosphorFilterButtonWithLabel = (props: Omit<PhosphorIconButtonWithLabelProps, "label">) =>
  <PhosphorIconButtonWithLabel label={RESX.GeneralLabels.Filter} {...props}>
    <PhosphorFunnel  {...props} />
  </PhosphorIconButtonWithLabel>;